import React from 'react';

import {useExpandedItems} from "../../hooks/useExpandedItems";
import Grid from "@material-ui/core/Grid";
import ChartSectionBordered, {ChartSectionPortfolioName} from "../ChartSectionBordered/ChartSectionBordered";
import {useExtendedAssetsData} from "../../hooks/useExtendedAssetsData";
import SinglePerformanceTableChart from "../charts/SinglePerformanceTable";


function PortfolioSinglePerformanceTable({customerId, portfolio, dataProvider, onChartSettingsChange, expanded, onExpandedItemsChange}) {

  const extendedAssetsData = useExtendedAssetsData(customerId, portfolio, dataProvider);

  return (
    <Grid item xs={12}>
      <ChartSectionBordered
        dataId={`performance-performance-table-${portfolio.depotNumber}`}
        title={(
          <ChartSectionPortfolioName portfolio={portfolio} />
        )}
        loading={extendedAssetsData.loading}
        error={extendedAssetsData.errors}
        displayError
        expanded={expanded}
        isPortfolioSection
        skipContentPadding
        borderLeftColor={portfolio.color}
        onExpanded={(newState) => onExpandedItemsChange(portfolio, newState)}
        content={(
          <SinglePerformanceTableChart
            data={extendedAssetsData.data}
            loading={extendedAssetsData.loading}
            error={extendedAssetsData.errors}
            onSortingChange={(sortData) => onChartSettingsChange('performanceTable', `${portfolio.depotNumber}-sorting`, sortData)}
            order='asc'
            orderBy='name'
          />
        )}
      />
    </Grid>
  )
}


function SinglePerformanceTable({customerId, portfolios, expandedItems, onExpandedItemsChange, dataProvider, onChartSettingsChange}) {

  const [isPtfExpanded, handleExpandedChanged] = useExpandedItems(expandedItems, onExpandedItemsChange, 'performanceTableItems');

  return (
    <Grid container spacing={2}>
      {portfolios.map((portfolio) => (
        <PortfolioSinglePerformanceTable
          key={portfolio.depotNumber}
          portfolio={portfolio}
          customerId={customerId}
          dataProvider={dataProvider}
          onChartSettingsChange={onChartSettingsChange}
          expanded={isPtfExpanded(portfolio)}
          onExpandedItemsChange={handleExpandedChanged}
        />
      ))}
    </Grid>
  )
}

SinglePerformanceTable.propTypes = {}

SinglePerformanceTable.propDefs = {}

SinglePerformanceTable.defaultProps = {}

export default SinglePerformanceTable;